"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const DailyViewLayout_1 = __importDefault(require("../DailyView/DailyViewLayout"));
const Image_1 = __importDefault(require("../DailyView/Image"));
const ImageOverlay_1 = __importDefault(require("../DailyView/ImageOverlay"));
const ImageOverlayText_1 = __importDefault(require("../DailyView/ImageOverlayText"));
const List_1 = __importDefault(require("../DailyView/List"));
const styled_components_1 = __importStar(require("styled-components"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ONE_HOUR = 3600000;
const ONE_MINUTE = 60000;
const ListContainer = styled_components_1.default.div `
  overflow-y: auto;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const blurAnimation = (0, styled_components_1.keyframes) `
  0% {
    filter: blur(5px);
  }
  100% {
    filter: blur(0);
  }
`;
const BlurWrapper = styled_components_1.default.div `
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: none;
    opacity: ${({ blur }) => (blur ? 1 : 0)};
    transition: opacity 0.2s ease-in-out;
    animation: ${({ blur }) => (blur ? blurAnimation : 'none')} 0.2s ease-in-out;
  }
`;
const NoActivitiesWrapper = styled_components_1.default.div `
  background-color: white;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10vw;
`;
const NoActivitiesText = styled_components_1.default.p `
  font-size: 45px;
  margin: 0;
  color: #1c1b1b;
`;
const NoActivitiesHint = styled_components_1.default.p `
  font-size: 32px;
  color: #444748;
  margin: 0;
`;
const DailyViewPage = ({ activities, brandInfo, timezone, showQrCode, selectedLocale, showToday, showTomorrow, showDayAfterTomorrow, }) => {
    const [shouldRerender, setShouldRerender] = (0, react_1.useState)(false);
    const [isBlurring, setIsBlurring] = (0, react_1.useState)(false);
    const [scrollTriggered, setScrollTriggered] = (0, react_1.useState)(false);
    const [hourlyRefreshKey, setHourlyRefreshKey] = (0, react_1.useState)(Date.now()); // Unique key for forced re-render every hour
    const [currentLocaleIndex, setCurrentLocaleIndex] = (0, react_1.useState)(0);
    const handleScrollToTop = (0, react_1.useCallback)(() => {
        const now = new Date();
        const minutes = now.getMinutes();
        if (minutes % 5 === 0) {
            setShouldRerender(true);
            setScrollTriggered(true);
        }
        if (selectedLocale.length > 1) {
            setCurrentLocaleIndex(prevIndex => (prevIndex + 1) % selectedLocale.length);
        }
    }, [selectedLocale.length]);
    // Blur the page when rerendering
    (0, react_1.useEffect)(() => {
        if (shouldRerender) {
            setIsBlurring(true);
            setTimeout(() => {
                setShouldRerender(false);
                setIsBlurring(false);
                setScrollTriggered(false);
            }, 200); // Duration matches the blur animation duration
        }
    }, [shouldRerender]);
    // Rerender the page every 5 minutes to update the next activity
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const minutes = now.getMinutes();
            if (minutes % 5 === 0 && !scrollTriggered) {
                setShouldRerender(true);
            }
        }, ONE_MINUTE);
        return () => {
            clearInterval(interval);
        };
    }, [scrollTriggered]);
    // Rerender the page forcefully every hour to update the next activity
    (0, react_1.useEffect)(() => {
        const now = new Date();
        const millisecondsUntilNextHour = ((60 - now.getMinutes()) * 60 - now.getSeconds()) * 1000 - now.getMilliseconds();
        const timeout = setTimeout(() => {
            setShouldRerender(true);
            setHourlyRefreshKey(Date.now());
            const hourlyInterval = setInterval(() => {
                setShouldRerender(true);
                setHourlyRefreshKey(Date.now());
            }, ONE_HOUR);
            return () => {
                clearInterval(hourlyInterval);
            };
        }, millisecondsUntilNextHour);
        return () => {
            clearTimeout(timeout);
        };
    }, []);
    if (!activities || activities.length === 0 || activities === undefined) {
        return (react_1.default.createElement(NoActivitiesWrapper, null,
            react_1.default.createElement(NoActivitiesText, null, i18n_js_1.default.t('daily_view_no_more_activities_title', { selectedLocale })),
            react_1.default.createElement(NoActivitiesHint, null, i18n_js_1.default.t('daily_view_no_more_activities', { selectedLocale }))));
    }
    const filterActivities = (activities) => {
        const now = new Date();
        const today = new Date(now);
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        const dayAfterTomorrow = new Date(today);
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
        // If none of the show* props are provided, show activities for all three days
        const showThreeDays = showToday === undefined || showTomorrow === undefined || showDayAfterTomorrow === undefined;
        return activities.filter(activity => {
            const activityStart = new Date(activity.start);
            const activityDate = new Date(activityStart);
            activityDate.setHours(0, 0, 0, 0);
            if (activityStart <= now) {
                return false;
            }
            if (showThreeDays) {
                return activityDate >= today && activityDate <= dayAfterTomorrow;
            }
            if (activityDate.getTime() === today.getTime() && (showToday || showToday === undefined))
                return true;
            if (activityDate.getTime() === tomorrow.getTime() && (showTomorrow || showTomorrow === undefined))
                return true;
            if (activityDate.getTime() === dayAfterTomorrow.getTime() &&
                (showDayAfterTomorrow || showDayAfterTomorrow === undefined))
                return true;
            return false;
        });
    };
    const currentLanguage = selectedLocale[currentLocaleIndex];
    const filteredByLanguageActivities = activities.filter(activity => (activity.locale === 'derobinson' ? 'de' : activity.locale) === currentLanguage);
    const filteredActivities = filterActivities(filteredByLanguageActivities);
    const transformedActivities = [];
    const seenIds = new Set();
    (0, react_1.useEffect)(() => {
        let intervalId;
        if (transformedActivities.length < 5) {
            intervalId = setInterval(() => {
                setShouldRerender(prev => !prev);
                if (selectedLocale.length > 1) {
                    setCurrentLocaleIndex(prevIndex => (prevIndex + 1) % selectedLocale.length);
                }
            }, ONE_MINUTE);
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [transformedActivities.length, selectedLocale.length]);
    filteredActivities.forEach(activity => {
        if (!seenIds.has(activity.id)) {
            seenIds.add(activity.id);
            transformedActivities.push({
                id: activity.id,
                placeName: activity.placeName,
                title: activity.title,
                start: new Date(activity.start).toISOString(),
                end: new Date(activity.end).toISOString(),
                images: activity.images,
                deeplink: activity.deeplink,
                bookable: activity.bookable,
                contentId: activity.contentId,
                locale: activity.locale,
            });
        }
    });
    const getNextActivity = () => {
        const currentTime = new Date().toISOString();
        for (let i = 0; i < transformedActivities.length; i++) {
            if (currentTime < transformedActivities[i].start) {
                return transformedActivities[i];
            }
        }
        return transformedActivities[transformedActivities.length - 1];
    };
    const nextActivity = getNextActivity();
    const upcomingActivities = nextActivity
        ? transformedActivities.filter(activity => new Date(activity.start) > new Date(nextActivity.start))
        : [];
    const hasMultipleUpcomingActivities = upcomingActivities.length > 0;
    const backgroundImages = {
        landscape: nextActivity.images &&
            nextActivity.images[0] &&
            nextActivity.images[0]['10:10'] &&
            nextActivity.images[0]['10:10'].XXL,
        portrait: nextActivity.images &&
            nextActivity.images[0] &&
            nextActivity.images[0]['2:1'] &&
            nextActivity.images[0]['2:1'].XXL,
    };
    return (react_1.default.createElement(BlurWrapper, { blur: isBlurring, key: hourlyRefreshKey },
        react_1.default.createElement(DailyViewLayout_1.default, null,
            react_1.default.createElement(Image_1.default, { imgSrc: backgroundImages, landscapeSrc: backgroundImages.landscape, portraitSrc: backgroundImages.portrait, brandInfo: brandInfo },
                react_1.default.createElement(ImageOverlay_1.default, null,
                    react_1.default.createElement(ImageOverlayText_1.default, { showQrCode: showQrCode, activity: nextActivity, timezone: timezone, currentLocale: currentLanguage }))),
            hasMultipleUpcomingActivities && (react_1.default.createElement(ListContainer, null,
                react_1.default.createElement(List_1.default, { items: transformedActivities, brandInfo: brandInfo, timezone: timezone, displayedItemId: nextActivity.id, onScrollToTop: handleScrollToTop, currentLocale: currentLanguage }))))));
};
const mapStoreToProps = store => ({
    activities: store.getValue('finalActivities'),
    brandInfo: store.getValue('brandInfo'),
    timezone: store.getValue('timezone'),
    showQrCode: store.getValue('hideAppDownloads'),
    selectedLocale: store.getValue('urlSpecifiedLocale'),
    showToday: store.getValue('showToday'),
    showTomorrow: store.getValue('showTomorrow'),
    showDayAfterTomorrow: store.getValue('showDayAfterTomorrow'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DailyViewPage);
